import { forwardRef } from 'react';

import clsx from 'clsx';

import { backdrop, backdropEnter, backdropExit } from './Modal.css';
import { ModalBackdropProps } from './types';

export interface ModalBackdropInternalProps extends ModalBackdropProps {
  isExiting?: boolean;
}

export const ModalBackdrop = forwardRef<HTMLDivElement, ModalBackdropInternalProps>(
  ({ onClick, className, isExiting, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={clsx(backdrop, isExiting ? backdropExit : backdropEnter, className)}
        onClick={onClick}
        {...props}
      />
    );
  },
);

ModalBackdrop.displayName = 'ModalBackdrop';
